import React from 'react';
import PropTypes from 'prop-types';

import { PLAN_TIER } from '@app/constant/plan-tier';

const FreeAccountTiers = ({ onTierSelect }) => {
  return (
    <div className="free-account-tiers">
      <h1 className="free-account-tiers__title">Get more out of WeTransfer</h1>
      <div className="tiers__list">
        <div className="tier">
          <div className="tier__content">
            <h2 className="tier__title">WeTransfer Account</h2>
            <h3 className="tier__subtitle">Free</h3>
            <ul className="tier__features">
              <li className="tier__feature-item">
                Send up to <strong>2GB</strong>
              </li>
              <li className="tier__feature-item">Manage transfers</li>
              <li className="tier__feature-item">
                Store up to <strong>5GB</strong>
              </li>
            </ul>
          </div>
          <button
            className="button button--enabled"
            onClick={onTierSelect}
            data-tier={PLAN_TIER.FREE}
          >
            Sign Up
          </button>
        </div>

        <div className="tier">
          <div className="tier__content">
            <h2 className="tier__title">WeTransfer Plus</h2>
            <h3 className="tier__subtitle">
              <div className="tier__price">
                <span>$12</span>
                <sup>USD</sup>
                <span className="tier__period">/ month</span>
              </div>
            </h3>
            <ul className="tier__features">
              <li className="tier__feature-item">
                Send up to <strong>20GB</strong>
              </li>
              <li className="tier__feature-item">Manage transfers</li>
              <li className="tier__feature-item">
                Store up to <strong>100GB</strong>
              </li>
              <li className="tier__feature-item">Your own backgrounds</li>
              <li className="tier__feature-item">A custom URL</li>
              <li className="tier__feature-item">Password-protect transfers</li>
            </ul>
          </div>
          <button
            className="button button--enabled button--inline"
            onClick={onTierSelect}
            data-tier={PLAN_TIER.PLUS}
          >
            Get WeTransfer Plus
          </button>
        </div>
      </div>
    </div>
  );
};

FreeAccountTiers.propTypes = {
  onTierSelect: PropTypes.func.isRequired,
};

export default React.memo(FreeAccountTiers);
